import cn from 'classnames';
import { ReactNode } from 'react';
import styles from './button.module.scss';

interface IProps {
  children: ReactNode;
  onClick: () => void;
  className?: string;
  color?: 'none' | 'green' | 'red' | 'gray';
}

const ButtonOutlined = ({
  children,
  onClick,
  className = '',
  color = 'none',
}: IProps): JSX.Element => {
  /* ClassNames */

  const classes: string = cn(styles.button, className, {
    [styles[`button-color-${color}`]]: color,
  });

  return (
    <button type="button" className={classes} {...{ children, onClick }} />
  );
};

export default ButtonOutlined;
